import styled from "styled-components";
import * as h from "../../../ui/_themes/helpers";
import { BaseButton } from "../../BaseButton";

export const Wrapper = styled(BaseButton)`
  color: ${h.getColor(
    "settingsWindowCloseButton",
    "settingsWindow.closeButton"
  )};

  &:hover {
    color: ${h.getHoverColor(
      "settingsWindowCloseButton",
      "settingsWindow.closeButton"
    )};
  }

  &:active {
    color: ${h.getPressedColor(
      "settingsWindowCloseButton",
      "settingsWindow.closeButton"
    )};
  }
`;
